import React, { memo, useEffect, useState, forwardRef } from "react";
import "./styles.css";

const areEqual = (prevProps, nextProps) => {
  const prevError = prevProps.errors?.[prevProps.name];
  const nextError = nextProps.errors?.[nextProps.name];
  
  return (
    prevProps.value === nextProps.value &&
    prevError === nextError &&
    prevProps.disabled === nextProps.disabled
  );
};

const Input = memo(
  forwardRef(({ form, disabled, ...props }, ref) => {
    const [showMsg, setShowMsg] = useState(false);
    const [focusedElement, setFocusedElement] = useState("");
    const [inputType, setInputType] = useState(
      props.showpasswordvisibility ? "password" : "text"
    );
    const [icon, setIcon] = useState("visibility_off");

    const toggleVisiblityPassword = () => {
      setInputType(inputType === "text" ? "password" : "text");
      setIcon(inputType === "text" ? "visibility_off" : "visibility");
    };

    useEffect(() => {
      const existError =
        props.errors &&
        Object.keys(props.errors).length > 0 &&
        props.errors[props.name];
      setShowMsg(existError);
    }, [props.errors, props.name]);

    const focusField = () => {
      if (disabled) return;
      setFocusedElement(document.activeElement.id);
    };

    const blurField = () => {
      setFocusedElement("");
    };

    return (
      <span className="field">
        <span className={`header ${showMsg ? "header-invalid" : ""}`}>
          {props.header}
        </span>
        <div
          className={`box-field box-input ${showMsg ? "input-error" : ""} ${
            focusedElement === props.id ? "input-valid" : ""
          } ${disabled ? "input-disabled" : ""}`}
        >
          {!props.showpasswordvisibility && (
            <input
              {...props}
              ref={ref}
              disabled={disabled}
              readOnly={disabled}
              className={`form-control form-transaction ${disabled ? "input-locked" : ""}`}
              onFocus={focusField}
              onBlur={blurField}
              type={inputType}
            />
          )}

          {props.showpasswordvisibility && (
            <div className="iconPassword">
              <div className="col-sm-10">
                <input
                  {...props}
                  ref={ref}
                  disabled={disabled}
                  readOnly={disabled}
                  className={`form-control form-transaction ${disabled ? "input-locked" : ""}`}
                  onFocus={focusField}
                  onBlur={blurField}
                  type={inputType}
                />
              </div>
              <div className="col-sm-2">
                <span
                  className={`material-icons show-password ${
                    inputType === "text" ? "show" : "hide"
                  }`}
                  onClick={toggleVisiblityPassword}
                >
                  {icon}
                </span>
              </div>
            </div>
          )}
        </div>
        {showMsg && <div className="msg-error">{props.errors[props.name]}</div>}
      </span>
    );
  }),
  areEqual
);

export default Input;
